import React, { useEffect, useState } from "react";
import { Col, Row, Button, Form, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAuthReducer } from "../../redux/Reducer/authReducer";
import { getChangePassword, getUserProfileDetails } from "../../redux/Actions";
import TwoFactorSetup from "./TwoFactorSetup";

const onFinish = (values) => {
  console.log("Success:", values);
};
const onFinishFailed = (errorInfo) => {
  console.log("Failed:", errorInfo);
};

const ComSecurity = () => {
  const navigate = useNavigate();
  const {
    authUser,
    userProfileDetails,
    changePassworddetail,
    changePasswordLoading,
  } = useSelector(getAuthReducer);
  const dispatch = useDispatch();

  const [newPasswordDetails, setNewPasswordDetails] = useState({
    old_password: "",
    password: "",
    email: userProfileDetails?.data?.email,
  });
  const [newPasswordErrors, setNewPasswordErrors] = useState({
    old_password: "",
    password: "",
    confirmPassword: "",
  });
  const [form] = Form.useForm();
  const formLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  useEffect(() => {
    dispatch(getUserProfileDetails(authUser?.user.id));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOldPasswordChange = (e) => {
    const passwordInput = e.target.value;
    setNewPasswordDetails({
      ...newPasswordDetails,
      old_password: passwordInput,
    });

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
    if (!passwordInput || !passwordRegex.test(passwordInput)) {
      let errorMsg = "Password must meet the following criteria:";
      if (passwordInput && passwordInput.length < 6) {
        errorMsg += " be at least 6 characters long,";
      }
      if (passwordInput && !/(?=.*[!@#$%^&*()_+])/.test(passwordInput)) {
        errorMsg += " include at least one symbol,";
      }
      if (passwordInput && !/(?=.*[a-z])/.test(passwordInput)) {
        errorMsg += " include at least one lowercase letter,";
      }
      if (passwordInput && !/(?=.*[A-Z])/.test(passwordInput)) {
        errorMsg += " include at least one uppercase letter,";
      }
      if (passwordInput && !/(?=.*\d)/.test(passwordInput)) {
        errorMsg += " include at least one digit,";
      }
      errorMsg = errorMsg.slice(0, -1);
      setNewPasswordErrors((prevErrors) => ({
        ...prevErrors,
        old_password: errorMsg,
      }));
    } else {
      setNewPasswordErrors((prevErrors) => ({
        ...prevErrors,
        old_password: "",
      }));
    }
  };

  const handlePasswordChange = (e) => {
    const passwordInput = e.target.value;
    setNewPasswordDetails({ ...newPasswordDetails, password: passwordInput });

    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{6,}$/;
    if (!passwordInput || !passwordRegex.test(passwordInput)) {
      let errorMsg = "Password must meet the following criteria:";
      if (passwordInput && passwordInput.length < 6) {
        errorMsg += " be at least 6 characters long,";
      }
      if (passwordInput && !/(?=.*[!@#$%^&*()_+])/.test(passwordInput)) {
        errorMsg += " include at least one symbol,";
      }
      if (passwordInput && !/(?=.*[a-z])/.test(passwordInput)) {
        errorMsg += " include at least one lowercase letter,";
      }
      if (passwordInput && !/(?=.*[A-Z])/.test(passwordInput)) {
        errorMsg += " include at least one uppercase letter,";
      }
      if (passwordInput && !/(?=.*\d)/.test(passwordInput)) {
        errorMsg += " include at least one digit,";
      }
      errorMsg = errorMsg.slice(0, -1);
      setNewPasswordErrors((prevErrors) => ({
        ...prevErrors,
        password: errorMsg,
      }));
    } else {
      setNewPasswordErrors((prevErrors) => ({ ...prevErrors, password: "" }));
    }
  };

  const handleNewPassword = (e) => {
    dispatch(getChangePassword(newPasswordDetails));
  };

  useEffect(() => {
    if (changePassworddetail === true) {
      navigate("/dashboard");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [changePassworddetail]);

  return (
    <>
      <Row
        gutter={{
          xs: 8,
          sm: 16,
          md: 24,
          lg: 32,
        }}
      >
        <Col className="gutter-row" span={24}>
          <Col className="dashboardtitlescol" span={24}>
            <p className="dashboardtitlestypog">Security</p>
          </Col>

          {/* Wrapper to layout Change Password and 2FA side-by-side on desktop */}
          <Row gutter={32}>
            {/* 👉 CHANGE PASSWORD SECTION */}
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
            >
              <div
                style={{
                  padding: "24px",
                  border: "1px solid #f0f0f0",
                  borderRadius: "8px",
                  background: "#fff",
                }}
              >
                <h4 style={{ marginBottom: "20px", color: "#252A4D" }}>
                  Change Password
                </h4>

                <Form
                  {...formLayout}
                  form={form}
                  onFinish={onFinish}
                  onFinishFailed={onFinishFailed}
                  size={"large"}
                  className="typography"
                >
                  <Form.Item
                    label={
                      <label className="typography fw-bold">
                        Old Password{" "}
                        <span style={{ color: "red", marginBottom: "2em" }}>
                          *
                        </span>
                      </label>
                    }
                    name="old_password"
                    rules={[{ message: "Please input your password!" }]}
                  >
                    <Input.Password
                      type="password"
                      value={newPasswordDetails.old_password}
                      onChange={handleOldPasswordChange}
                      placeholder="Enter your old password here"
                    />
                  </Form.Item>
                  {newPasswordErrors.old_password && (
                    <p className="error typography mb-3">
                      Password: {newPasswordErrors.old_password}
                    </p>
                  )}

                  <Form.Item
                    label={
                      <label className="typography fw-bold">
                        New Password{" "}
                        <span style={{ color: "red", marginBottom: "2em" }}>
                          *
                        </span>
                      </label>
                    }
                    name="password"
                    rules={[{ message: "Please input your password!" }]}
                  >
                    <Input.Password
                      type="password"
                      value={newPasswordDetails.password}
                      onChange={handlePasswordChange}
                      placeholder="Enter your password"
                    />
                  </Form.Item>
                  {newPasswordErrors.password && (
                    <p className="error typography mb-3">
                      Password: {newPasswordErrors.password}
                    </p>
                  )}

                  <Button
                    onClick={handleNewPassword}
                    className="signupbutton typography mt-3"
                    htmlType="submit"
                    disabled={
                      newPasswordDetails.password === "" ||
                      newPasswordErrors.password !== "" ||
                      changePasswordLoading
                    }
                    block
                  >
                    {changePasswordLoading ? "Loading..." : "Change Password"}
                  </Button>
                </Form>
              </div>
            </Col>

            {/* 👉 2FA SETUP SECTION */}
            <Col
              xs={{ span: 24 }}
              sm={{ span: 24 }}
              md={{ span: 12 }}
              lg={{ span: 12 }}
              xl={{ span: 12 }}
              style={{ marginTop: "0" }}
            >
              <TwoFactorSetup />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
export default ComSecurity;
